export const getPercentage = (value, total) => {
  const percentage = (value / total) * 100;

  return Number.isNaN(percentage) ? '0%' : `${percentage.toFixed(2)}%`;
};

export const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1);
